export function invitationExpiryText(expiresAt: string, now = Date.now()): string {
  const end = new Date(expiresAt);
  if (!Number.isFinite(end.getTime())) return 'Expiry unavailable — create the invitation again.';
  const date = end.toLocaleString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  const remaining = end.getTime() - now;
  if (remaining <= 0) return `Expired on ${date}. Create the invitation again.`;
  const days = Math.ceil(remaining / 86400000);
  return `Expires on ${date} · ${days === 1 ? 'less than 24 hours' : `${days} days`} remaining`;
}
